<template>
  <v-btn
    v-if="$vuetify.breakpoint.xsOnly"
    block
    text
    small
    @click="$store.commit('mapSetCollapsed', !$store.state.map.collapsed)"
  >
    <v-icon v-if="$store.state.map.collapsed">mdi-chevron-down</v-icon>
    <v-icon v-else>mdi-chevron-up</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'CollapseMapBtn'
}
</script>
